var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "path-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Conversation-Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---add-private-album---view-shared-images",
    transform: "translate(-402.000000, -942.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(68.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(322.000000, 952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icReportOption.cea10ca5",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11627906,1.04761905 C2.85576474,1.04761905 1.02325581,2.92375914 1.02325581,5.23809523 L1.02325581,16.7619047 C1.02325581,19.0762408 2.85576474,20.952381 5.11627906,20.952381 L16.8837209,20.952381 C19.1442352,20.952381 20.9767442,19.0762408 20.9767442,16.7619047 L20.9767442,5.23809523 C20.9767442,2.92375914 19.1442352,1.04761905 16.8837209,1.04761905 L5.11627906,1.04761905 Z M5.11627906,0 L16.8837209,0 C19.7093638,0 22,2.34517511 22,5.23809523 L22,16.7619047 C22,19.6548249 19.7093638,22 16.8837209,22 L5.11627906,22 C2.29063616,22 0,19.6548249 0,16.7619047 L0,5.23809523 C0,2.34517511 2.29063616,0 5.11627906,0 Z M11.281131,4.71428571 C11.641578,4.71428571 12.1986324,5.17985347 12.1986324,5.54565671 L11.8709534,13.19427 C11.8709534,13.5600733 11.5760423,13.8593668 11.2155953,13.8593668 C10.8551483,13.8593668 10.5602372,13.5600733 10.5602372,13.19427 L10.3963976,5.57891156 C10.3963976,5.21310831 10.953452,4.71428571 11.281131,4.71428571 Z M11.2155953,15.5221089 C11.7726497,15.5221089 12.1986324,15.9544217 12.1986324,16.5197541 C12.1986324,17.0850863 11.7726497,17.5173993 11.2155953,17.5173993 C10.6585409,17.5173993 10.2325581,17.0850863 10.2325581,16.5197541 C10.2325581,15.9544217 10.6585409,15.5221089 11.2155953,15.5221089 Z",
    id: "path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportWhite);
export default __webpack_public_path__ + "static/media/icReportWhite.bd1f7927737bc6b3e5991348bccec7a3.svg";
export { ForwardRef as ReactComponent };